// extracted by mini-css-extract-plugin
module.exports = {"item":"PriceItem_item__z71Hj","collapsed":"PriceItem_collapsed__3AXqn"};